import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DISPATCHER_ORDER_TIMELINE_STEPS_ICONS } from './configs';
import { LocalTimeDate } from 'hooks';
import { classNames } from 'utils/classNames';
import { TIME_FORMAT } from 'utils/date';
import { IDispatcherOrderTimeline } from 'types/api';
import { TDispatcherOrderTimelineStepKey } from './types';
import styles from './DispatcherOrderTimeline.module.css';
import { Flex, Typography as T, TimelineItemProps } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';

export const StepRender: FC<{
	value: string | undefined;
	timeLineKey: TDispatcherOrderTimelineStepKey;
	isNextStep: boolean;
	isCurrentStep: boolean;
}> = ({ isNextStep, isCurrentStep, timeLineKey, value }) => {
	const { t: tDispatcher } = useTranslation('dispatcher');

	// ! render
	return (
		<>
			<T.Text
				className={classNames({
					[styles.stepper_label]: true,
					[styles.grey_text]: isNextStep,
				})}
			>
				{tDispatcher(`order_card.timeline.${timeLineKey}`)}
			</T.Text>

			{value && (
				<T.Text
					className={classNames({
						[styles.stepper_value]: true,
						[styles.grey_text]: !isCurrentStep,
						[styles.highlight_text]: isCurrentStep,
					})}
				>
					<LocalTimeDate
						date={value}
						format={TIME_FORMAT}
					/>
				</T.Text>
			)}
		</>
	);
};

export const getOrderTimelineSteps = (
	timeline: IDispatcherOrderTimeline,
	currentStepIndex: number
): TimelineItemProps[] => {
	const steps = timeline.timeline_order.map<TimelineItemProps>((key, index) => {
		const isNextStep = index > currentStepIndex;
		const isCurrentStep = index === currentStepIndex;
		const iconColor = isNextStep ? 'var(--info-color)' : 'var(--ant-primary-color)';

		return {
			key,
			dot: DISPATCHER_ORDER_TIMELINE_STEPS_ICONS[key] ?? <CheckCircleOutlined />,
			color: iconColor,
			children: (
				<Flex gap='small'>
					<StepRender
						value={timeline[key]}
						timeLineKey={key}
						isNextStep={isNextStep}
						isCurrentStep={isCurrentStep}
					/>
				</Flex>
			),
		};
	});

	return steps;
};
